"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendRequestQuotePurchaseNotification = exports.sendRequestTrialNotification = exports.sendRequestSKUNotification = exports.sendRequestAdditionalSeatsNotification = exports.sendRequestAccessNotification = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var sendRequestAccessNotification = function sendRequestAccessNotification(productName) {
  return _apiClient.default.post('self-service/v2/request-access', {
    data: {
      productName: productName
    }
  });
};

exports.sendRequestAccessNotification = sendRequestAccessNotification;

var sendRequestAdditionalSeatsNotification = function sendRequestAdditionalSeatsNotification(productName) {
  return _apiClient.default.post('self-service/v2/request-additional-seats', {
    data: {
      productName: productName
    }
  });
};

exports.sendRequestAdditionalSeatsNotification = sendRequestAdditionalSeatsNotification;

var sendRequestSKUNotification = function sendRequestSKUNotification(productName, cta) {
  return _apiClient.default.post('self-service/v2/request-sku', {
    data: {
      productName: productName,
      cta: cta
    }
  });
};

exports.sendRequestSKUNotification = sendRequestSKUNotification;

var sendRequestTrialNotification = function sendRequestTrialNotification(productName, cta) {
  return _apiClient.default.post('self-service/v2/request-trial', {
    data: {
      productName: productName,
      cta: cta
    }
  });
};

exports.sendRequestTrialNotification = sendRequestTrialNotification;

var sendRequestQuotePurchaseNotification = function sendRequestQuotePurchaseNotification(cta) {
  return _apiClient.default.post('self-service/v2/request-quote-purchase', {
    data: {
      cta: cta
    }
  });
};

exports.sendRequestQuotePurchaseNotification = sendRequestQuotePurchaseNotification;